import React, { useEffect, useState } from 'react'
import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import { Link } from 'react-router-dom'
import { Cell, Label, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'

import { defaultToEmptyString, twoDigits } from '../../../assets/ts/formatting/formatting'
import CustomTooltip from '../custom-tooltip'
import './charts.css'
import './piecharts.css'

const ByPieChart = ({
  dueoutHighPriority,
  dueoutNormalPriority,
  inquirySourceCSSCount,
  inquirySourceCustomerCount,
  isDueout,
}: any) => {
  const totalAmount = inquirySourceCSSCount + inquirySourceCustomerCount
  const formattedData = [
    {
      fill: '#3458AA',
      name: isDueout ? 'High' : 'Customer',
      value: isDueout ? dueoutHighPriority : inquirySourceCustomerCount,
    },
    {
      fill: '#60A2C7',
      name: isDueout ? 'Normal' : 'CSS',
      value: isDueout ? dueoutNormalPriority : inquirySourceCSSCount,
    },
  ]
  return (
    <Col className='align-items-stretch w-100-important my-2 d-flex' lg={4} md={6} sm={12}>
      <Card className='w-100'>
        <Card.Body className='d-flex flex-column'>
          <div className='d-flex flex-row' style={{ margin: 'auto 0' }}>
            <ResponsiveContainer height={300} width='65%'>
              <PieChart aria-label='Inquiries By Source Chart' className='tooltiphidefocus'>
                <Pie
                  cx='50%'
                  cy='45%'
                  data={formattedData}
                  dataKey='value'
                  innerRadius='55%'
                  isAnimationActive={false}
                  outerRadius='90%'
                  paddingAngle={5}
                  tabIndex={0}
                >
                  {formattedData &&
                    formattedData.map((entry, index) => (
                      <Cell aria-label={entry.name} fill={entry.fill} key={index} />
                    ))}
                  <Label
                    className='piecharttotallabel'
                    position='center'
                    style={{ fill: '#555555', fontWeight: '600' }}
                    value='Total'
                  />
                  <Label
                    className={
                      totalAmount.length >= 5 ? 'piechartamountlabel-sm' : 'piechartamountlabel'
                    }
                    position='center'
                    style={{ fill: '#000000', fontWeight: '700' }}
                    value={defaultToEmptyString(twoDigits(totalAmount))}
                  />
                </Pie>
                <Tooltip content={<CustomTooltip />} isAnimationActive={false} />
              </PieChart>
            </ResponsiveContainer>
            <ul style={{ margin: 'auto 0', width: '35%' }}>
              {formattedData &&
                formattedData.map((entry, index) => {
                  if (entry.value > 0) {
                    return (
                      <li
                        key={`list-${index}`}
                        style={{
                          alignItems: 'center',
                          display: 'flex',
                          listStyle: 'none',
                          marginBottom: 10,
                          width: '100%',
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: `${entry.fill}`,
                            border: '3px solid white',
                            borderRadius: '50%',
                            boxShadow: '0px 3px 3px darkgray',
                            height: 15,
                            marginRight: 5,
                            width: 15,
                          }}
                        ></div>
                        <div className='piechartlegend' style={{ fontWeight: 600 }}>
                          {' '}
                          <span>{defaultToEmptyString(entry.name.toUpperCase())}</span> (
                          {defaultToEmptyString(twoDigits(entry.value))})
                        </div>
                      </li>
                    )
                  }
                })}
            </ul>
          </div>
        </Card.Body>
      </Card>
    </Col>
  )
}

export default ByPieChart
